import React, { useRef } from 'react';
import { Button } from '@chakra-ui/react';

import Dialog from '../../../../../common/components/ConfirmationDialog/Dialog';
import { useTranslations } from '../../../../../contexts/LocalizationContext';
import { useScannedRelevosContext } from '../../../../../contexts/ScannedRelevosContext';
import { useDepositResultContext } from '../../../context/DepositResultContext/DepositResultContext';
import { DepositResultModalBody } from './DepositResultModalBody';

type DepositResultModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const DepositResultModal = ({ isOpen, onClose }: DepositResultModalProps) => {
  const translations = useTranslations();
  const cancelRef = useRef(null);
  const { setScannedRelevos } = useScannedRelevosContext();
  const { resetDepositResult } = useDepositResultContext();

  const handleClose = () => {
    onClose();
    setScannedRelevos([]);
    resetDepositResult();
  };

  return (
    <Dialog
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={handleClose}
      size="3xl"
      dialogHeader={translations('deposit_summary_heading')}
      dialogFooter={
        <Button
          minW="100px"
          variant="orangeSolid"
          color="black"
          margin="auto"
          title={translations('ok')}
          onClick={handleClose}
          mr={3}
        >
          {translations('ok')}
        </Button>
      }
    >
      <DepositResultModalBody />
    </Dialog>
  );
};
